resizeBy// ie: Engine.ui.misc();
jQuery(function ($) {
    "use strict";
    var Engine = {
        ui: {
            misc: function () {
                $(function () {
                    // Add .scrolled class to header when scroll position > 100px
                    $(window).on('scroll', function () {
                        if ($(this).scrollTop() > 100) {
                            $('header').addClass('scrolled');
                        } else {
                            $('header').removeClass('scrolled');
                        }
                    });

                    // Smooth scroll for anchor links
                    $('a[href^="#"]').on('click', function (e) {
                        e.preventDefault();

                        // Get the target element
                        var target = $(this.hash);
                        if (target.length) {
                            // Animate scroll to target with 100px offset
                            $('html, body').animate({
                                scrollTop: target.offset().top - 100
                            }, 800);

                            // Update URL without the hash
                            if (history.pushState) {
                                history.pushState(null, null, ' ');
                            } else {
                                location.hash = '';
                            }
                        }
                    });

                    // Append arrow indicator to dropdown parent links.
                    // tabindex="0" makes it focusable so .arrow:focus can reveal the menu.
                    $('.menu-item-has-children').not(':has(> .arrow)').append('<span class="arrow" tabindex="0"></span>');

                    // Toggle the sibling .dropdown-menu open/closed when the arrow is clicked.
                    // Class-based, not an inline display: an inline style outlived the
                    // hover rules and left desktop panels stuck open.
                    $(document).on('click', '.arrow', function (e) {
                        e.preventDefault();
                        e.stopPropagation();
                        const $arrow = $(this);
                        $arrow.toggleClass('is-open');
                        $arrow.siblings('.dropdown-menu').toggleClass('is-open');
                    });

                    // Crossing back up to desktop, drop any mobile open state so the
                    // hover rules take over from a clean slate.
                    $(window).on('resize', function () {
                        if (window.innerWidth >= 1280) {
                            $('.dropdown-menu.is-open, .arrow.is-open').removeClass('is-open');
                        }
                    });

                    let isOpen = false;

                    $("#menuIcon").on('click', function () {
                        if (!isOpen) {
                            // Transition to Close Icon (X)
                            $('.top').attr('d', 'M1 1L19 15');
                            $('.middle').css('opacity', '0');
                            $('.bottom').attr('d', 'M1 15L19 1');
                        } else {
                            // Transition to Hamburger Menu Icon
                            $('.top').attr('d', 'M2 2H25');
                            $('.middle').css('opacity', '1');
                            $('.bottom').attr('d', 'M2 18H25');
                        }

                        isOpen = !isOpen;
                    });



                    // Products carousel — variable width, ~4 visible on desktop,
                    // with pagination dots that only show on mobile.
                    new Swiper('.products-swiper', {
                        slidesPerView: 'auto',
                        spaceBetween: 20,
                        grabCursor: true,
                        autoplay: {
                            delay: 5000,
                            disableOnInteraction: false,
                            pauseOnMouseEnter: true,
                        },
                        pagination: {
                            el: '.products-pagination',
                            clickable: true,
                        },
                        breakpoints: {
                            768: {
                                spaceBetween: 24,
                            },
                        },
                    });

                    // Popular courses carousel — variable-width like products,
                    // with pagination dots that only show on mobile.
                    new Swiper('.popular-courses-swiper', {
                        slidesPerView: 'auto',
                        spaceBetween: 20,
                        grabCursor: true,
                        autoplay: {
                            delay: 5000,
                            disableOnInteraction: false,
                            pauseOnMouseEnter: true,
                        },
                        pagination: {
                            el: '.popular-courses-pagination',
                            clickable: true,
                        },
                        breakpoints: {
                            768: {
                                spaceBetween: 24,
                            },
                        },
                    });

                    // Testimonials carousel — 1 slide below 768px, 2 above.
                    new Swiper('.testimonials-swiper', {
                        slidesPerView: 1,
                        spaceBetween: 20,
                        grabCursor: true,
                        autoplay: {
                            delay: 5000,
                            disableOnInteraction: false,
                            pauseOnMouseEnter: true,
                        },
                        breakpoints: {
                            768: {
                                slidesPerView: 2,
                                spaceBetween: 24,
                            },
                        },
                    });

                    $(window).on('scroll', function () {
                        if ($(this).scrollTop() > 1000) {
                            $('#back-top').fadeIn();
                            $("#back-top").addClass('active');
                        } else {
                            $('#back-top').fadeOut();
                            $("#back-top").removeClass('active');
                        }
                    });

                    $('#back-top').on('click', function () {
                        $('body,html').animate({
                            scrollTop: 0
                        }, 100);
                        return false;
                    });

                    // Checkout — swap Place Order button to a loading state on submit.
                    // WooCommerce fires `checkout_error` if validation fails, so we
                    // restore the original label in that case.
                    const $checkoutForm = $('form.woocommerce-checkout');
                    if ($checkoutForm.length) {
                        const loadingLabel = 'Placing order…';
                        let originalLabel = '';

                        $checkoutForm.on('submit', function () {
                            const $btn = $('#place_order');
                            if (!$btn.length || $btn.hasClass('is-loading')) {
                                return;
                            }
                            originalLabel = $btn.text();
                            $btn
                                .addClass('is-loading')
                                .prop('disabled', true)
                                .html('<span class="aiims-spinner" aria-hidden="true"></span>' + loadingLabel);
                        });

                        $(document.body).on('checkout_error', function () {
                            const $btn = $('#place_order');
                            if (!$btn.hasClass('is-loading')) {
                                return;
                            }
                            $btn
                                .removeClass('is-loading')
                                .prop('disabled', false)
                                .text(originalLabel);
                        });
                    }

                });
            }, // end misc
        }, // end ui
        //utils: {

        //}, // end utils
    };
    Engine.ui.misc();
    //Engine.utils.sliders();
});

// ── Virtual course banner — Date → Time ──────────────────────────────
// A virtual course can run two cohorts in a day, so the banner asks for the
// date first and then the time of day. The Time select is only rendered by
// PHP when some date actually has more than one sitting; this narrows it to
// whichever date is chosen.
//
// Without JS the select still lists the first date's sittings and the enrol
// page resolves date + slot itself, so nothing is unbookable.
(function () {
    "use strict";

    function initVirtualBanner() {
        const form = document.querySelector(".aiims-banner-virtual");
        if (!form) return;

        const dateSel = form.querySelector("[data-banner-virtual-date]");
        const slotSel = form.querySelector("[data-banner-virtual-slot]");
        if (!dateSel || !slotSel) return; // Single-sitting course: nothing to filter.

        let byDate = {};
        try {
            byDate = JSON.parse(form.dataset.slots || "{}");
        } catch (e) {
            return;
        }

        const fillSlots = function () {
            const slots = byDate[dateSel.value] || [];
            slotSel.innerHTML = "";
            slots.forEach(function (s) {
                const o = document.createElement("option");
                o.value = s.slot || "";
                o.textContent = s.time || "";
                slotSel.appendChild(o);
            });
            // Shown even with a single sitting, so the banner always states the
            // time alongside the date. With one option there is simply nothing
            // to change.
            slotSel.hidden = slots.length === 0;
        };

        dateSel.addEventListener("change", fillSlots);
        fillSlots();
    }

    if (document.readyState !== "loading") {
        initVirtualBanner();
    } else {
        document.addEventListener("DOMContentLoaded", initVirtualBanner);
    }
})();

// ── Main course page banner — Location + Date enrol selector ─────────
// Fetches the course schedule via AJAX (so it isn't embedded in page HTML),
// fills the Location → Date dropdowns, and enables the Enrol Now button
// (deep-linking into the prefilled enrol form) only once both are chosen.
//
// On-site only. A course's Online and Virtual delivery are written up on their
// own child pages, which the main page links to under the banner — so this
// widget lists venues and nothing else. It used to offer an "Online (any day)"
// entry above the venues, which now belongs on the online page.
(function () {
    "use strict";

    function initBannerEnrol() {
        var root = document.querySelector(".aiims-banner-enrol");
        if (!root) return;

        var sessions = [];
        var enrolUrl = root.dataset.enrolUrl || "";
        var course = root.dataset.course || "";
        var productId = root.dataset.product || "";
        var ajaxUrl = root.dataset.ajax || "";
        var locSel = root.querySelector("[data-banner-location]");
        var dateSel = root.querySelector("[data-banner-date]");
        var btn = root.querySelector("[data-banner-enrol-btn]");

        function uniq(a) { return Array.from(new Set(a.filter(Boolean))); }
        function ordinal(n) { var v = n % 100; if (v >= 11 && v <= 13) return "th"; switch (n % 10) { case 1: return "st"; case 2: return "nd"; case 3: return "rd"; default: return "th"; } }
        function formatDate(str) {
            var p = String(str).split("-");
            if (p.length !== 3) return str;
            var d = new Date(+p[0], +p[1] - 1, +p[2]);
            if (isNaN(d.getTime())) return str;
            var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
            return d.getDate() + ordinal(d.getDate()) + " " + months[d.getMonth()] + " " + d.getFullYear();
        }

        function populateLocations() {
            locSel.innerHTML = '<option value="">Select location</option>';
            uniq(sessions.filter(function (s) { return s.type === "On-site"; }).map(function (s) { return s.location; }))
                .forEach(function (l) { var o = document.createElement("option"); o.value = l; o.textContent = l; locSel.appendChild(o); });
            locSel.disabled = false;
        }

        function fillDates() {
            dateSel.hidden = false;
            dateSel.disabled = !locSel.value;
            dateSel.innerHTML = '<option value="">Select date</option>';
            sessions.filter(function (s) { return s.type === "On-site" && s.location === locSel.value; })
                .slice().sort(function (a, b) { return a.date < b.date ? -1 : (a.date > b.date ? 1 : 0); })
                .forEach(function (s) { var o = document.createElement("option"); o.value = s.date; o.textContent = formatDate(s.date); dateSel.appendChild(o); });
        }

        function updateButton() {
            var loc = locSel.value;
            var date = dateSel.value;
            var ok = !!loc && !!date;
            btn.classList.toggle("opacity-50", !ok);
            btn.classList.toggle("pointer-events-none", !ok);
            btn.setAttribute("aria-disabled", ok ? "false" : "true");
            btn.setAttribute("tabindex", ok ? "0" : "-1");
            if (!ok) return;
            var params = new URLSearchParams();
            if (course) params.set("course", course);
            params.set("type", "On-site");
            params.set("location", loc);
            var row = sessions.find(function (s) { return s.type === "On-site" && s.location === loc; });
            if (row && row.state) params.set("state", row.state);
            params.set("date", date);
            btn.href = enrolUrl + "?" + params.toString();
        }

        locSel.addEventListener("change", function () { fillDates(); updateButton(); });
        dateSel.addEventListener("change", updateButton);

        if (productId && ajaxUrl) {
            fetch(ajaxUrl + "?action=aiims_course_sessions&product_id=" + encodeURIComponent(productId), { credentials: "same-origin" })
                .then(function (r) { return r.json(); })
                .then(function (j) {
                    // The response also reports online/virtual availability;
                    // both are ignored here — those modes have their own pages.
                    sessions = (j && j.success && j.data && j.data.sessions) ? j.data.sessions : [];
                    populateLocations();
                    fillDates();
                    updateButton();
                })
                .catch(function () { locSel.innerHTML = '<option value="">Unavailable</option>'; });
        }
    }

    if (document.readyState !== "loading") {
        initBannerEnrol();
    } else {
        document.addEventListener("DOMContentLoaded", initBannerEnrol);
    }
})();

// ── Find A Course bar — cascading Course / State / Location / Date ────
// Fetches the course list via AJAX (so it isn't embedded in page HTML) and
// drives the four dependent selects; the form GET-submits to /enrol/.
(function () {
    "use strict";

    function initFindCourse() {
        var root = document.querySelector(".aiims-find-course");
        if (!root) return;

        var ajaxUrl = root.dataset.ajax || "";
        var courseSel = root.querySelector("[data-fc-course]");
        var stateSel = root.querySelector("[data-fc-state]");
        var locSel = root.querySelector("[data-fc-location]");
        var dateSel = root.querySelector("[data-fc-date]");
        if (!courseSel || !stateSel || !locSel || !dateSel) return;

        var courses = [];
        var MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

        function uniq(a) { return Array.from(new Set(a.filter(Boolean))); }
        function formatDate(d) {
            var p = String(d).split("-");
            if (p.length !== 3) return d;
            var dt = new Date(+p[0], +p[1] - 1, +p[2]);
            if (isNaN(dt.getTime())) return d;
            return dt.getDate() + " " + MONTHS[dt.getMonth()] + " " + dt.getFullYear();
        }

        function baseLocations() {
            var seen = {}, out = [];
            var src = courseSel.value
                ? ((courses.find(function (c) { return c.slug === courseSel.value; }) || {}).locations || [])
                : courses.reduce(function (a, c) { return a.concat(c.locations || []); }, []);
            src.forEach(function (l) { if (l.name && !seen[l.name]) { seen[l.name] = true; out.push(l); } });
            return out;
        }
        function stateOptions() { return uniq(baseLocations().map(function (l) { return l.state; })); }
        function locationOptions() {
            return baseLocations()
                .filter(function (l) { return !stateSel.value || l.state === stateSel.value; })
                .map(function (l) { return l.name; });
        }
        function dateOptions() {
            var seen = {}, out = [];
            baseLocations()
                .filter(function (l) { return (!stateSel.value || l.state === stateSel.value) && (!locSel.value || l.name === locSel.value); })
                .forEach(function (l) { (l.dates || []).forEach(function (d) { if (d && !seen[d]) { seen[d] = true; out.push(d); } }); });
            return out.sort();
        }

        function fill(sel, placeholder, items, isDate) {
            sel.innerHTML = '<option value="">' + placeholder + "</option>";
            items.forEach(function (it) {
                var o = document.createElement("option");
                o.value = it;
                o.textContent = isDate ? formatDate(it) : it;
                sel.appendChild(o);
            });
        }
        function renderCourses() {
            courseSel.innerHTML = '<option value="">By Course</option>';
            courses.forEach(function (c) { var o = document.createElement("option"); o.value = c.slug; o.textContent = c.name; courseSel.appendChild(o); });
        }
        function renderState() { fill(stateSel, "By State", stateOptions(), false); }
        function renderLocation() { fill(locSel, "By Location", locationOptions(), false); }
        function renderDate() { fill(dateSel, "By Date", dateOptions(), true); }

        // Unlock each select only once the previous one has a value
        // (Course → State → Location → Date).
        function syncDisabled() {
            stateSel.disabled = !courseSel.value;
            locSel.disabled = !stateSel.value;
            dateSel.disabled = !locSel.value;
        }

        courseSel.addEventListener("change", function () { stateSel.value = ""; locSel.value = ""; dateSel.value = ""; renderState(); renderLocation(); renderDate(); syncDisabled(); });
        stateSel.addEventListener("change", function () { locSel.value = ""; dateSel.value = ""; renderLocation(); renderDate(); syncDisabled(); });
        locSel.addEventListener("change", function () { dateSel.value = ""; renderDate(); syncDisabled(); });

        if (ajaxUrl) {
            fetch(ajaxUrl + "?action=aiims_find_course_data", { credentials: "same-origin" })
                .then(function (r) { return r.json(); })
                .then(function (j) {
                    courses = (j && j.success && j.data && j.data.courses) ? j.data.courses : [];
                    renderCourses();
                    renderState();
                    renderLocation();
                    renderDate();
                    syncDisabled();
                })
                .catch(function () { });
        }
    }

    if (document.readyState !== "loading") {
        initFindCourse();
    } else {
        document.addEventListener("DOMContentLoaded", initFindCourse);
    }
})();

// ── Locations section — state dropdown, suburb list (with course types +
//    times) and Leaflet map. Fetches data via AJAX (not embedded in HTML). ──
(function () {
    "use strict";

    function initLocations() {
        var root = document.querySelector(".aiims-locations");
        if (!root) return;

        var ajaxUrl = root.dataset.ajax || "";
        var labelEl = root.querySelector("[data-loc-state-label]");
        var toggleBtn = root.querySelector("[data-loc-dropdown-toggle]");
        var dropdown = root.querySelector("[data-loc-dropdown]");
        var stateListEl = root.querySelector("[data-loc-state-list]");
        var suburbListEl = root.querySelector("[data-loc-suburb-list]");
        var mapEl = root.querySelector("[data-loc-map]");
        if (!toggleBtn || !stateListEl || !suburbListEl || !mapEl) return;

        var states = [];
        var markerUrl = "";
        var courseDatesUrl = "";
        var stateValue = "";
        var active = null;
        var map = null;
        var markers = [];
        var open = false;
        var activeLi = null;

        function esc(s) { var d = document.createElement("div"); d.textContent = (s == null ? "" : s); return d.innerHTML; }
        function currentState() { return states.find(function (x) { return x.value === stateValue; }) || null; }
        function suburbs() { var s = currentState(); return s ? s.suburbs : []; }
        function isActive(sub) { return !!active && active.name === sub.name && active.venue === sub.venue; }

        function setDropdown(state) {
            open = state;
            stateListEl.hidden = !state;
            toggleBtn.setAttribute("aria-expanded", state ? "true" : "false");
            var caret = toggleBtn.querySelector("svg");
            if (caret) caret.classList.toggle("rotate-180", state);
        }

        function directionsHref(sub) {
            // Use the venue + street address (not lat/lng) as the destination.
            var addr = (sub.address || "").replace(/\s*\n\s*/g, ", ").trim();
            var q = (sub.venue ? sub.venue + ", " : "") + (addr || sub.name);
            return "https://www.google.com/maps/dir/?api=1&destination=" + encodeURIComponent(q);
        }

        // Matches WP's sanitize_title, which is what the Course Dates page runs
        // its ?location= filter through — so the slugs line up on both ends.
        function slugify(s) {
            return String(s == null ? "" : s).toLowerCase()
                .replace(/[^a-z0-9]+/g, "-")
                .replace(/^-+|-+$/g, "");
        }

        // Course Dates page, pre-filtered to this venue. '' when no page uses
        // the Course Dates template yet, in which case the link is skipped.
        function courseDatesHref(sub) {
            if (!courseDatesUrl) return "";
            var sep = courseDatesUrl.indexOf("?") === -1 ? "?" : "&";
            return courseDatesUrl + sep + "location=" + encodeURIComponent(slugify(sub.name));
        }

        function renderStateList() {
            stateListEl.innerHTML = "";
            states.forEach(function (s) {
                var li = document.createElement("li");
                var btn = document.createElement("button");
                btn.type = "button";
                btn.className = "w-full text-left px-5 py-3 text-custom-navy hover:bg-primary-50" + (s.value === stateValue ? " bg-primary-50" : "");
                btn.innerHTML = "<span>" + esc(s.label) + "</span>" + (s.region ? '<span class="text-primary text-xs block">' + esc(s.region) + "</span>" : "");
                btn.addEventListener("click", function () { selectState(s); });
                li.appendChild(btn);
                stateListEl.appendChild(li);
            });
        }

        var PIN = '<svg width="24" height="24" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.3997 11.9994C16.8833 10.2646 15.1024 8.99951 13.1998 8.99951C10.8803 8.99951 9 10.8798 9 13.1993C9 15.3151 10.5646 17.1081 12.5999 17.3992" stroke="#E9ECEF" stroke-width="1.79993" stroke-linecap="round"/><path d="M23.938 11.9995C23.3612 6.64108 18.6693 2.3999 13.198 2.3999C7.35356 2.3999 2.39844 7.23928 2.39844 13.1104C2.39844 19.0957 7.44291 23.233 12.0856 26.107C12.4246 26.2984 12.808 26.3989 13.198 26.3989C13.588 26.3989 13.9714 26.2984 14.3104 26.107C14.6159 25.92 14.923 25.7273 15.2304 25.5287" stroke="#E9ECEF" stroke-width="1.79993" stroke-linecap="round"/><path d="M21.0013 14.3994C23.9236 14.3994 26.4011 16.8191 26.4011 19.7547C26.4011 22.7369 23.8833 24.8299 21.5575 26.2529C21.3881 26.3486 21.1963 26.3989 21.0013 26.3989C20.8064 26.3989 20.6146 26.3486 20.4452 26.2529C18.1237 24.8159 15.6016 22.7472 15.6016 19.7547C15.6016 16.8191 18.0791 14.3994 21.0013 14.3994Z" stroke="#E9ECEF" stroke-width="1.79993"/><path d="M21 19.7993H21.0102" stroke="#E9ECEF" stroke-width="2.3999" stroke-linecap="round" stroke-linejoin="round"/></svg>';

        function coursesHtml(sub) {
            if (!sub.courses || !sub.courses.length) return "";
            return '<ul class="list-none! m-0! mt-1.5 flex flex-col">' +
                sub.courses.map(function (c) {
                    return '<li class="flex flex-wrap gap-x-2 text-xs">' +
                        '<span class="text-custom-navy font-bold">' + esc(c.type) +":</span>" +
                        (c.time ? '<span class="text-primary">' + esc(c.time) + "</span>" : "") +
                        "</li>";
                }).join("") +
                "</ul>";
        }

        function renderSuburbs() {
            suburbListEl.innerHTML = "";
            activeLi = null;
            suburbs().forEach(function (sub) {
                var li = document.createElement("li");
                li.className = "bg-on-dark rounded-xl border border-[#b7cee1] p-4!";
                if (isActive(sub)) { activeLi = li; }
                var datesHref = courseDatesHref(sub);
                li.innerHTML =
                    '<button type="button" class="w-full flex flex-row items-start gap-4 text-left transition-opacity ' + (isActive(sub) ? "opacity-100" : "opacity-60 hover:opacity-100") + '">' +
                    '<div class="bg-custom-navy p-3 rounded-full shrink-0">' + PIN + "</div>" +
                    '<div class="flex flex-col gap-0.5 min-w-0 flex-1">' +
                    '<span class="text-custom-navy text-lg font-extrabold leading-tight">' + esc(sub.name) + "</span>" +
                    (sub.venue ? '<span class="text-brand-tertiary text-sm font-bold">' + esc(sub.venue) + "</span>" : "") +
                    (sub.address ? '<span class="text-primary text-xs leading-relaxed whitespace-pre-line">' + esc(sub.address) + "</span>" : "") +
                    coursesHtml(sub) +
                    '<span class="mt-1.5 flex flex-wrap items-center gap-x-3 gap-y-1">' +
                    '<a href="' + directionsHref(sub) + '" target="_blank" rel="noopener" class="text-brand-tertiary text-xs font-bold hover:underline">Get Directions</a>' +
                    (datesHref
                        ? '<a href="' + datesHref + '" class="text-brand-tertiary text-xs font-bold hover:underline">View Course Dates</a>'
                        : "") +
                    "</span>" +
                    "</div>" +
                    "</button>";
                li.querySelector("button").addEventListener("click", function () { selectSuburb(sub); });
                // Both links sit inside the card button — stop the click bubbling
                // so following one doesn't also re-select the suburb behind it.
                li.querySelectorAll("a").forEach(function (a) {
                    a.addEventListener("click", function (e) { e.stopPropagation(); });
                });
                suburbListEl.appendChild(li);
            });
        }

        function buildIcon(activeFlag) {
            var html = activeFlag
                ? '<div class="relative w-14 h-14 overflow-visible"><span class="absolute inset-0 rounded-full bg-brand-tertiary opacity-60 animate-ping"></span><span class="absolute inset-2 rounded-full bg-brand-tertiary/30"></span><img src="' + markerUrl + '" alt="" class="relative w-14 h-14 drop-shadow-lg" /></div>'
                : '<div class="relative w-9 h-9 opacity-90 hover:opacity-100 transition-opacity"><span class="absolute inset-0 rounded-full bg-custom-navy/30"></span><img src="' + markerUrl + '" alt="" class="relative w-9 h-9 drop-shadow" /></div>';
            return L.divIcon({ html: html, className: "", iconSize: activeFlag ? [56, 56] : [36, 36], iconAnchor: activeFlag ? [28, 56] : [18, 36] });
        }

        function renderMarkers(fitBounds) {
            if (!map) return;
            markers.forEach(function (m) { map.removeLayer(m); });
            markers = [];
            var points = [];
            suburbs().forEach(function (sub) {
                if (sub.lat == null || sub.lng == null) return;
                var m = L.marker([sub.lat, sub.lng], { icon: buildIcon(isActive(sub)), zIndexOffset: isActive(sub) ? 1000 : 0 })
                    .addTo(map)
                    .on("click", function () { selectSuburb(sub, true); });
                m.__sub = sub;
                markers.push(m);
                points.push([sub.lat, sub.lng]);
            });
            if (fitBounds && points.length) {
                if (points.length === 1) {
                    map.setView(points[0], 13, { animate: true });
                } else {
                    map.fitBounds(L.latLngBounds(points).pad(0.2), { animate: true });
                }
            }
        }

        function refreshActive() {
            if (!map || !active || active.lat == null) return;
            markers.forEach(function (m) {
                var a = isActive(m.__sub);
                m.setIcon(buildIcon(a));
                m.setZIndexOffset(a ? 1000 : 0);
            });
            map.setView([active.lat, active.lng], map.getZoom(), { animate: true });
        }

        // First location that actually carries coordinates — preferring the
        // active one, then its state, then any state. Lat/lng are optional in
        // Theme Settings, and setView([null, null]) throws inside Leaflet and
        // would take the whole section down with it.
        function firstWithCoords() {
            if (hasCoords(active)) return active;
            var lists = [(states[0] && states[0].suburbs) || []];
            states.forEach(function (s) { lists.push(s.suburbs || []); });
            for (var i = 0; i < lists.length; i++) {
                for (var j = 0; j < lists[i].length; j++) {
                    if (hasCoords(lists[i][j])) return lists[i][j];
                }
            }
            return null;
        }

        function hasCoords(s) {
            return !!s && s.lat != null && s.lng != null;
        }

        function initMap() {
            if (typeof L === "undefined") return;
            var centre = firstWithCoords();
            if (!centre) return;
            map = L.map(mapEl, { scrollWheelZoom: false, zoomControl: true }).setView([centre.lat, centre.lng], 13);
            L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
                maxZoom: 19,
                attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            }).addTo(map);
            renderMarkers(true);
        }

        function selectState(s) {
            stateValue = s.value;
            labelEl.textContent = s.label;
            setDropdown(false);
            if (s.suburbs.length) { active = s.suburbs[0]; }
            renderSuburbs();
            renderMarkers(true);
        }

        // Nearest scrollable ancestor (the suburb <ul> on mobile, the <aside>
        // on desktop) — so we scroll that box, never the whole page.
        function findScroller(el) {
            var node = el ? el.parentElement : null;
            while (node && node !== document.body) {
                var oy = getComputedStyle(node).overflowY;
                if ((oy === "auto" || oy === "scroll") && node.scrollHeight > node.clientHeight + 1) {
                    return node;
                }
                node = node.parentElement;
            }
            return null;
        }

        function scrollToActive() {
            if (!activeLi) return;
            var scroller = findScroller(activeLi);
            if (!scroller) return;
            var liRect = activeLi.getBoundingClientRect();
            var scRect = scroller.getBoundingClientRect();
            scroller.scrollBy({ top: (liRect.top - scRect.top) - 12, behavior: "smooth" });
        }

        function selectSuburb(sub, scrollList) {
            active = sub;
            renderSuburbs();
            refreshActive();
            if (scrollList) { scrollToActive(); }
        }

        toggleBtn.addEventListener("click", function () { setDropdown(!open); });
        document.addEventListener("click", function (e) { if (dropdown && !dropdown.contains(e.target)) setDropdown(false); });

        function boot(data) {
            if (!data) return;
            states = data.states || [];
            markerUrl = data.markerUrl || "";
            courseDatesUrl = data.courseDatesUrl || "";
            if (!states.length) return;
            stateValue = states[0].value;
            labelEl.textContent = states[0].label;
            active = states[0].suburbs[0] || null;
            renderStateList();
            renderSuburbs();
            initMap();
        }

        // Prefer the data localized into the page (no round-trip → instant
        // render); fall back to the AJAX endpoint only if it isn't present.
        if (window.aiimsLocations) {
            boot(window.aiimsLocations);
        } else if (ajaxUrl) {
            fetch(ajaxUrl + "?action=aiims_locations_data", { credentials: "same-origin" })
                .then(function (r) { return r.json(); })
                .then(function (j) { if (j && j.success) boot(j.data); })
                .catch(function () { });
        }
    }

    if (document.readyState !== "loading") {
        initLocations();
    } else {
        document.addEventListener("DOMContentLoaded", initLocations);
    }
})();

/* -------------------------------------------------------------------------
 * Online courses sticky bar (parts/section-online-bar.php) — keep the Enrol
 * Now button's href in sync with the chosen course, deep-linking to the enrol
 * form as ?course=…&type=Online.
 * ---------------------------------------------------------------------- */
(function () {
    "use strict";

    function initOnlineBar() {
        const bar = document.querySelector(".aiims-online-bar");
        if (!bar) return;

        const select = bar.querySelector("[data-online-course]");
        const button = bar.querySelector("[data-online-enrol]");
        if (!select || !button) return;

        const base = bar.getAttribute("data-enrol-base") || "/enrol/";

        const update = function () {
            let query = "type=Online";
            if (select.value) {
                query = "course=" + encodeURIComponent(select.value) + "&" + query;
            }
            button.setAttribute("href", base + (base.indexOf("?") === -1 ? "?" : "&") + query);
        };

        select.addEventListener("change", update);
        update();
    }

    if (document.readyState !== "loading") {
        initOnlineBar();
    } else {
        document.addEventListener("DOMContentLoaded", initOnlineBar);
    }
})();
